import { connect } from "react-redux"
import React from 'react'
import SearchPage from 'components/SearchPage/SearchPage.jsx'
import actions from 'actions'

const {
    searchWebinars,
    saveSearchedWebinars
} = actions

class Search extends React.Component {
    constructor(props) {
      super(props)
    }

    searchWebinars(q) {
        try {
            // if(q.toLowerCase() === 'igpnea' || q.toLowerCase() === 'ipna') q = 'Irish General Practice Nurses Educational Assoc.'
            this.props.searchWebinars(q)
        } catch(err) {
            console.log(err)
        }
    }

    componentDidMount() {
        this.searchWebinars(this.props.location.query.q)
    }

    componentWillUnmount() {
        this.props.cleanWebinars()
    }
    
    componentWillReceiveProps = nextProps => {
        if (nextProps.location.query.q !== this.props.location.query.q) {
            this.searchWebinars(nextProps.location.query.q)
        }
    }


    render() {
        const {
            searchList,
            isSearchResultsLoading,
            cleanWebinars,
            location
        } = this.props

        return (
            <main className="site--width">
                <div className="section_webinars">
                    <h2 className="main_title">Search for {location.query.q}</h2>
                </div>
                <SearchPage
                    webinars={searchList}
                    isLoading={isSearchResultsLoading}
                />
            </main>
        )
    }
}

const mapStateToProps = state => ({
    searchList: state.webinars.searchList,
    isSearchResultsLoading: state.webinars.isSearchResultsLoading
})

const mapDispatchToProps = dispatch => ({
    searchWebinars: searchString => dispatch(searchWebinars(searchString)),
    cleanWebinars: () => dispatch(saveSearchedWebinars([]))
})

export default connect(mapStateToProps, mapDispatchToProps)(Search)


// WEBPACK FOOTER //
// ./src/containers/SearchPage/SearchPage.js